import { KLineData } from "klinecharts";
import { readStyle } from "./indicatorUtils";

export const createAwesomeOscillator = (settings: any) => {
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const upS = readStyle(styles, "aoUp", "#26A69A");
  const downS = readStyle(styles, "aoDown", "#EF5350");

  return {
    name: "ao",
    shortName: "AO",
    calcParams: [] as number[],
    series: "normal" as const,
    figures: [{ key: "ao", title: "AO: ", type: "bar" }],
    styles: {
      bars: [
        {
          upColor: upS.color,
          downColor: downS.color,
          noChangeColor: "#888888",
        },
      ],
    },
    regenerateFigures: () => [{ key: "ao", title: "AO: ", type: "bar" }],
    calc: (dataList: KLineData[]) => {
      const n = dataList.length;
      const results: Array<{ ao?: number }> = new Array(n);
      let sum5 = 0;
      let sum34 = 0;

      for (let i = 0; i < n; i++) {
        const median = (dataList[i]!.high + dataList[i]!.low) / 2;
        sum5 += median;
        sum34 += median;
        if (i >= 5) sum5 -= (dataList[i - 5]!.high + dataList[i - 5]!.low) / 2;
        if (i >= 34)
          sum34 -= (dataList[i - 34]!.high + dataList[i - 34]!.low) / 2;

        if (i >= 33) {
          results[i] = { ao: sum5 / 5 - sum34 / 34 };
        } else {
          results[i] = {};
        }
      }

      return results;
    },
  };
};
